@if (!data().redacted) {
  @if (data().gross) {
    <div class="section">
      <div class="section-header">
        <span>Zwischensumme (netto)</span>
        <ui-product-prices-formatter
          class="net-sum"
          [showThousandthsPlace]="false"
          [price]="data().net">
        </ui-product-prices-formatter>
      </div>
    </div>

    @if (minimumOrderValue(); as minOrderValue) {
      @let totalRemaining = minOrderValue.total.remaining ?? 0;

      <div class="section expandable">
        <div class="section-header" (click)="toggleShow(showMinimumOrderValue)">
            <span>
              Lieferkosten sparen
             <ui-icon class="chevron" [faName]="showMinimumOrderValue()? 'chevron-up' : 'chevron-down'" faStyle="light"></ui-icon>
            </span>

          @if (minOrderValue.total.status !== 'reached') {
            <span class="min-order-value-label">
                Noch
                <ui-product-prices-formatter
                  [showThousandthsPlace]="false"
                  [price]="totalRemaining">
              </ui-product-prices-formatter>
              </span>
          } @else {
            <span class="min-order-value-label reached">Versandkostenfrei</span>
          }
        </div>

        <ui-expander-content [expanded]="showMinimumOrderValue()">
          <div class="section-content min-order-value-content">
              <span>
                Es fehlen noch
                <span class="highlighted">
                  <ui-product-prices-formatter
                    [showThousandthsPlace]="false"
                    [price]="totalRemaining">
                  </ui-product-prices-formatter>
                  netto (ohne Pfand)
                </span>
                bis zur kostenfreien Lieferung.
              </span>

            @if (minOrderValue.nonTobacco.remaining; as nonTobaccoRemaining) {
              <span class="highlighted">
                Food, Frische, TKK & Non-Food:
                </span>
              <span>
                  <ui-product-prices-formatter
                    [showThousandthsPlace]="false"
                    [price]="nonTobaccoRemaining">
                  </ui-product-prices-formatter>
                  netto (ohne Pfand)
                </span>
            }

            @if (minOrderValue.tobacco.remaining; as tobaccoRemaining) {
              <span class="highlighted">
                Tabakwaren & E-Zigaretten:
                </span>
              <span>
                  <ui-product-prices-formatter
                    [showThousandthsPlace]="false"
                    [price]="tobaccoRemaining">
                  </ui-product-prices-formatter>
                  netto (ohne Pfand)
                </span>
            }
          </div>
        </ui-expander-content>
      </div>
    }

    @if (data().deposit) {
      <div class="section expandable">
        <div class="section-header" (click)="toggleShow(showDeposit)">
            <span>
              <ui-icon class="prefix-header-icon" faName="recycle" faStyle="solid"></ui-icon>
              Pfand (netto)
              <ui-icon class="chevron" [faName]="showDeposit()? 'chevron-up' : 'chevron-down'" faStyle="light"></ui-icon>
            </span>

          <ui-product-prices-formatter [showThousandthsPlace]="false" [price]="data().deposit "></ui-product-prices-formatter>
        </div>

        <ui-expander-content title="Pfand" [expanded]="showDeposit()">
          <div class="monetary-list">
            @if (!orderExtendedDepositEnabled()) {
              <div class="monetary-list-item">
                <div>Pfand (netto)</div>
                <ui-product-prices-formatter [showThousandthsPlace]="false" [price]="data().deposit"></ui-product-prices-formatter>
              </div>
            } @else {
              <div class="monetary-list-item">
                <div>Nichtlagerartikel</div>
                <ui-product-prices-formatter [showThousandthsPlace]="false" [price]="12"></ui-product-prices-formatter>
              </div>
              <div class="monetary-list-item">
                <div>Pfand</div>
                <ui-product-prices-formatter [showThousandthsPlace]="false" [price]="data().deposit"></ui-product-prices-formatter>
              </div>
              <div class="monetary-list-item">
                <div>Dienstleistung</div>
                <ui-product-prices-formatter [showThousandthsPlace]="false" [price]="34"></ui-product-prices-formatter>
              </div>
              <div class="monetary-list-item">
                <div>Ladehilfsmittel</div>
                <ui-product-prices-formatter [showThousandthsPlace]="false" [price]="56"></ui-product-prices-formatter>
              </div>
              <div class="monetary-list-item">
                <div>Non Food / Hartware</div>
                <ui-product-prices-formatter [showThousandthsPlace]="false" [price]="78"></ui-product-prices-formatter>
              </div>
              <div class="monetary-list-item">
                <div>Wert-Art. (Belast,Gutsch)</div>
                <ui-product-prices-formatter [showThousandthsPlace]="false" [price]="9.10"></ui-product-prices-formatter>
              </div>
            }
          </div>
        </ui-expander-content>
      </div>
    }


    <div class="section expandable">
      <div class="section-header" (click)="toggleShow(showTaxes)">
          <span>
            <ui-icon class="prefix-header-icon" faName="percentage" faStyle="light"></ui-icon>
            Mehrwertsteuer (gesamt)
            <ui-icon class="chevron" [faName]="showTaxes()? 'chevron-up' : 'chevron-down'" faStyle="light"></ui-icon>
          </span>
        <ui-product-prices-formatter [showThousandthsPlace]="false" [price]="data().tax"></ui-product-prices-formatter>
      </div>

      <ui-expander-content title="MWST" [expanded]="showTaxes()">
        <div class="monetary-list">
          @for (taxItem of data().taxes; track taxItem) {
            <div class="monetary-list-item">
              <div>Mehrwertsteuer ({{ taxItem.taxRate }}%)</div>
              <ui-product-prices-formatter [showThousandthsPlace]="false" [price]="taxItem.amount"></ui-product-prices-formatter>
            </div>
          }
          <div class="monetary-list-item">
            <div>Mehrwertsteuer (gesamt)</div>
            <div>
              <ui-product-prices-formatter [showThousandthsPlace]="false" [price]="data().tax"></ui-product-prices-formatter>
            </div>
          </div>
        </div>
      </ui-expander-content>
    </div>

    <div class="section">
      <div class="section-header">
        <span>Summe (brutto)</span>
        <ui-product-prices-formatter [showThousandthsPlace]="false" class="gross-value" [price]="data().gross"></ui-product-prices-formatter>
      </div>
    </div>
  }
}
